import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { TAnnualExchangeRateRow } from './types';

export const tableStructure: TTableStructure<keyof TAnnualExchangeRateRow>[] = [
	{
		name: 'Id',
		selector: 'id',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Year',
		selector: 'year',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STATUS_NO_BG,
		align: ETableStructureAlign.LEFT,
		separateFilter: true,
		separateFilterAutocomplete: true,
		filter: [
			['2022', '2022'],
			['2023', '2023'],
			['2024', '2024'],
			['2025', '2025'],
			['2026', '2026'],
		],
	},
	{
		name: 'Month',
		selector: 'month',
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	// {
	// 	name: 'Period',
	// 	selector: 'year',
	// 	show: true,
	// 	sortable: true,
	// 	filterable: false,
	// 	colSpan: 1,
	// 	type: ETableStructureType.DATE_MONTH,
	// 	align: ETableStructureAlign.LEFT,
	// 	value: (item) => `${item.year}-${item.month}`,
	// },
	{
		name: 'Currency',
		selector: 'currency',
		show: true,
		sortable: true,
		filterable: false,
		// searchable: true,
		separateFilter: true,
		separateFilterAutocomplete: true,
		colSpan: 1,
		type: ETableStructureType.CURRENCY,
		align: ETableStructureAlign.LEFT,
	},

	{
		name: 'Rate',
		selector: 'toEurRate',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
	},
];
